<template>
  <div
    v-if="showBannerCookie"
    class="search-banner"
  >
    <!-- <div class="search-banner__container">
      <h5>
        Como podemos melhorar?
        <span>Conta pra gente ;)</span>
      </h5>
      <p>Nos ajude nessa jornada respondendo nossa pesquisa.</p>
      <img
        class="icon-aol"
        svg-inline
        src="../../../static/images/alvaro_banner_icon.svg"
        alt="Banner icon"
      >
      <div class="search-banner__right">
        <button @click="openForm()">
          Responder Pesquisa
        </button>
      </div>
    </div>
    <div
      class="button-close"
      @click="closeBanner()"
    >
      <img
        svg-inline
        src="../../../static/images/icon-close-white.svg"
        alt="Fechar pesquisa"
      >
    </div> -->
  </div>
</template>

<script>
import { getCookie, saveCookie } from '../../utils/auth-utils'

export default {
  name: 'SearchBanner',
  data: () => {
    return {
      showBanner: true
    }
  },
  computed: {
    showBannerCookie: function () {
      return !getCookie('surveyAnswered') && this.showBanner
    }
  },
  methods: {
    closeBanner() {
      this.showBanner = false
    },
    openForm() {
      this.showBanner = false
      saveCookie('surveyAnswered', true)
      window.open(
        'https://forms.office.com/pages/responsepage.aspx?id=TEoc9EsxnUmaejlYGUTHBIpCqfOh_j9Aqaoj0lpoGqdUQk9CMDUzVFJVRkJYUExQUE9LODVHU1I2RC4u',
        '_blank'
      )
    }
  }
}
</script>

<style lang="scss">
.search-banner {
  background-image: url('/static/images/banner-prepago.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  border-radius: 8px;
  width: 100%;
  height: 180px;
  display: flex;
  position: relative;
  color: #fff;
  font-family: 'Exo 2', sans-serif !important;
  margin-bottom: 24px;

  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px 0 32px;
    width: 100%;

    h5 {
      font-size: 24px;
      max-width: 300px;

      span {
        font-size: 16px;
        display: block;
        line-height: 19.2px;
      }
    }

    p {
      font-size: 14px;
      margin: 0 15px;
    }
  }

  &__right {
    display: flex;
    align-items: center;

    button {
      background: transparent;
      border: 2px solid #fff;
      width: 188px;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      font-weight: 600;
      justify-content: center;

      &:hover {
        background-color: rgba(252, 242, 248, 0.2);
      }
    }
  }

  .icon-aol {
    opacity: 0.4;
    margin: 0;
    margin-right: 15px;
  }

  .button-close {
    position: absolute;
    right: 8px;
    top: 1px;
    cursor: pointer;
  }
}
</style>
